import { SEGMENTS } from '@/app/router/routes'

// Map UPPER_CASE keys to SEGMENTS values for backwards compatibility
export const ROUTES_NEGOTIATIONS = {
  ASSIGNMENT: SEGMENTS.negotiations.assignment,
  DETAILS_NEGOTIATION: SEGMENTS.negotiations.detailsNegotiation,
  PAYMENT_AGREEMENT: SEGMENTS.negotiations.paymentAgreement,
  PRODUCTION_ORDER: SEGMENTS.negotiations.productionOrder,
  REFERRAL_PROGRAM: SEGMENTS.negotiations.referralProgram,
  RESERVATION_SENDING: SEGMENTS.negotiations.reservationSending,
  EXTENDED_DUE_DILIGENCE: SEGMENTS.negotiations.extendedDueDiligence,
  PRINT: SEGMENTS.negotiations.print,
  HISTORY_STATES: SEGMENTS.negotiations.historyStates,
  ATTACHMENTS: SEGMENTS.negotiations.attachments,
  MOBILE_PREVIEW: SEGMENTS.negotiations.mobilePreview
} as const

/**
 * Los pasos del modo VER, en el orden de la subnav. El índice de cada uno es su `step`, así que
 * `POSITION_STEPS_NEGOTIATIONS` tiene que moverse con esta lista: agregar uno en el medio corre
 * todos los de abajo.
 *
 * «Vista móvil» va al FINAL y sólo acá: es lectura pura sobre un expediente ya cargado, no un paso
 * del formulario, y en modo crear ni siquiera hay inmueble que previsualizar.
 *
 * ☠️ Es la secuencia COMPLETA, no la que se recorre. «Vista móvil» sólo existe sobre una venta
 * cerrada; en el resto, leer esta lista de largo deja «Siguiente» habilitado en «Historial de
 * estados» y lo manda a una ruta que redirige al primer paso en vez de mostrar algo. El recorrido
 * real lo da `getViewSteps`.
 */
export const STEPS_NEGOTIATIONS_VIEW = [
  SEGMENTS.negotiations.assignment,
  SEGMENTS.negotiations.detailsNegotiation,
  SEGMENTS.negotiations.paymentAgreement,
  SEGMENTS.negotiations.extendedDueDiligence,
  SEGMENTS.negotiations.referralProgram,
  SEGMENTS.negotiations.productionOrder,
  SEGMENTS.negotiations.attachments,
  SEGMENTS.negotiations.print,
  SEGMENTS.negotiations.historyStates,
  SEGMENTS.negotiations.mobilePreview
]

type ViewStepsInput = {
  /** `isClientAppEligible` del expediente: venta cerrada, con `neg_`, en modo ver. */
  eligible: boolean
}

/**
 * Los pasos del modo VER que de verdad se recorren con «Atrás» y «Siguiente». Es la misma
 * condición que dibuja la pestaña «Vista móvil» en la subnav y que monta su ruta: si una de las
 * tres la escribiera aparte, «Siguiente» llevaría a un paso que no se ve.
 *
 * Como «Vista móvil» va última, sacarla no corre ningún índice: el `step` de los otros nueve sigue
 * siendo el de `POSITION_STEPS_NEGOTIATIONS`.
 */
export function getViewSteps({ eligible }: ViewStepsInput): string[] {
  if (eligible) return STEPS_NEGOTIATIONS_VIEW
  return STEPS_NEGOTIATIONS_VIEW.filter((step) => step !== SEGMENTS.negotiations.mobilePreview)
}

export const STEPS_NEGOTIATIONS = [
  SEGMENTS.negotiations.assignment,
  SEGMENTS.negotiations.detailsNegotiation,
  SEGMENTS.negotiations.paymentAgreement,
  SEGMENTS.negotiations.extendedDueDiligence,
  SEGMENTS.negotiations.referralProgram,
  SEGMENTS.negotiations.productionOrder,
  SEGMENTS.negotiations.attachments
]

export const POSITION_STEPS_NEGOTIATIONS = {
  ASSIGNMENT: 1,
  DETAILS_NEGOTIATION: 2,
  PAYMENT_AGREEMENT: 3,
  EXTENDED_DUE_DILIGENCE: 4,
  REFERRAL_PROGRAM: 5,
  PRODUCTION_ORDER: 6,
  ATTACHMENTS: 7,
  PRINT: 8,
  HISTORY_STATES: 9,
  MOBILE_PREVIEW: 10
}
